import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { withdrawalService, type WithdrawalStatus } from '@/api/services/withdrawalService'

export function useWithdrawals(status?: WithdrawalStatus) {
  return useQuery({
    queryKey: ['withdrawals', status ?? 'all'],
    queryFn: () => withdrawalService.list(status),
    staleTime: 15_000,
  })
}

export function useApproveWithdrawal() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, admin_notes }: { id: number; admin_notes?: string }) =>
      withdrawalService.approve(id, admin_notes),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['withdrawals'] }),
  })
}

export function useRejectWithdrawal() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, reason, admin_notes }: { id: number; reason: string; admin_notes?: string }) =>
      withdrawalService.reject(id, { reason, admin_notes }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['withdrawals'] }),
  })
}
